export * from './PlatoonTab';
export * from './TeachersTab';
export * from './SoldiersTab';



// WEBPACK FOOTER //
// ./src/pages/base-managment/platoons/tabs/index.js